import { m } from '@pricedrop/i18n';
import Download from 'lucide-react/dist/esm/icons/download';

const currentYear = new Date().getFullYear();

function getFooterLinks() {
  return [
    { text: m.footer_termsOfUse(), href: '/terms-of-use' },
    { text: m.footer_privacyPolicy(), href: '/privacy-policy' },
    { text: m.footer_accessibility(), href: '/accessibility' },
    { text: m.footer_faq(), href: '/faq' },
    { text: m.footer_contact(), href: '/contact' },
  ];
}

export function Footer() {
  return (
    <footer className="border-t bg-background">
      <div className="container mx-auto flex flex-col items-center justify-between gap-4 py-10 md:h-auto md:py-6">
        <div className="flex flex-col items-center gap-4 px-8 md:flex-row md:gap-2 md:px-0">
          <p className="text-center text-sm leading-loose text-muted-foreground">
            Pricedrop {m.footer_description()}
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-4 md:gap-6">
          <a
            href="/extension"
            className="inline-flex items-center text-sm font-medium text-muted-foreground transition-colors hover:text-primary"
          >
            {m.footer_extension()}
            <Download className="ms-2 h-4 w-4" />
          </a>
          {getFooterLinks().map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-medium text-muted-foreground transition-colors hover:text-primary"
            >
              {link.text}
            </a>
          ))}
        </div>
        <div className="text-center text-sm text-muted-foreground">
          <p>&copy; {currentYear} Pricedrop.</p>
        </div>
      </div>
    </footer>
  );
}
